import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getGranteeProperty = (id) => {
  const url = `${API_ROOT}/proposal/${id}/grantee/property`
  return doGet(url)
}

export const saveGranteeProperty = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/grantee/property`
  return doPost(url, request)
}

export const updateGranteeProperty = (id, request, propertyId) => {
  const url = `${API_ROOT}/proposal/${id}/grantee/property/${propertyId}`
  return doPut(url, request)
}

export const uploadGranteeFile = (projectVersionId, contractFileTypeId, request) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/grantee/attachment/${contractFileTypeId}`
  return doPost(url, request)
}

export const getGranteeAllFile = (projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/grantee/attachment`
  return doGet(url)
}

export const downloadGranteeFileById = (projectVersionId, fileId, isCVFile) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/grantee/attachment/${fileId}/download?isCVFile=${isCVFile || ''}`
  return doDownload(url)
}

export const updateGranteeFileName = (projectVersionId, fileId, request) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/grantee/attachment/${fileId}`
  return doPut(url, request)
}

export const deleteGranteeFileById = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/grantee/attachment/${fileId}`
  return doDelete(url)
}

export const validatedFilebyId = (projectVersionId, fileId, isValidated) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/grantee/attachment/${fileId}/validated?isValidated=${isValidated}`
  return doPut(url)
}
